export default __webpack_public_path__ + "static/media/MyStory.1f2a4b55.svg";